import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-stone-50" data-id="element-89" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-90" data-mp="1cf9ko959c1gj">
        <div className="text-center mb-16" data-id="element-91" data-mp="1cgb7favmyce3">
          <p className="text-rose-700 font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-92" data-mp="2a2s4cf0ginzb">
            Everything You Need to Know
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-800" data-id="element-93" data-mp="253p0uz04kptg">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-94" data-mp="1v5hjif1xc5qx">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-white border border-stone-200 rounded-xl overflow-hidden" data-id="element-95" data-mp="oqgtsr3hsjss" data-mpi={index}>
                <h3 data-id="element-96" data-mp="1kn70s1bbitoe">
                  <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-rose-700" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} data-id="element-97" data-mp="1korwvvda6kod">
                    <span className="font-bold text-base md:text-lg text-stone-800" data-id="element-98" data-mp="11ve9cbbwdgis">
                      {faq.q}
                    </span>
                    <ChevronDown className={`text-rose-700 transition-transform duration-200 ease-out shrink-0 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-99" data-mp="s044zgy10x1u" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-100" data-mp="mzq3khqxklcs">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-101" data-mp="2pmn23ot6vhwg">
                      <div className="px-6 pb-5 text-stone-600 border-t border-stone-200 pt-4 space-y-2" data-id="element-102" data-mp="2yp65ca0vzwj8">
                        {faq.a.map(line => <p key={line} data-id="element-103" data-mp="1n8xz9ym8y32t">{line}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}